
import React,{ useEffect} from 'react'
import { useDispatch, useSelector } from "react-redux";
import { setSelectedUser, clearUnreadCount } from '../redux/userSlice';
import { format, isToday, isYesterday, parseISO } from 'date-fns';

const OtherUser = ({ user }) => {

    const dispatch = useDispatch();
    const { selectedUser, onlineUsers, unreadMessages , lastMessages } = useSelector(store => store.user);
    const { messages } = useSelector(store => store.message);

    if (!user || !user._id) return null;
    const isOnline = onlineUsers?.includes(user._id);
    const unreadCount = unreadMessages[user._id] || 0;
    
     

    // Get all messages with this user
    const userMessages = messages?.filter(msg => 
       msg.senderId === user._id || msg.receiverId === user._id
    ) || [];
        
       
    // Find the most recent message (either sent or received)
    const lastMessage = [...userMessages].sort((a, b) => 
       new Date(b.createdAt) - new Date(a.createdAt)
    )[0];

       
    const lastUnreadMessage = unreadCount > 0 
        ? userMessages.filter(msg => msg.senderId === user._id && msg.status !== 'seen').pop()
        : null;

        const lastMessageContent = lastMessages?.[user._id] || user.lastMessageContent || '';

    const formatMessageTime = (dateString) => {
        if (!dateString) return '';
        const date = parseISO(dateString);
        if (isToday(date)) return format(date, 'h:mm a');
        if (isYesterday(date)) return 'Yesterday';
        // return format(date, 'MM/dd/yyyy');
        return format(date, 'dd-MM-yyyy');  
    };

    const handleClick = () => {
        dispatch(setSelectedUser(user));
        if (unreadCount > 0) {
            dispatch(clearUnreadCount({ userId: user._id }));
        }
    };

  

    return (
        <>
        <div 
            onClick={handleClick}
            className={`flex items-center p-3 hover:bg-zinc-100 cursor-pointer 
                ${selectedUser?._id === user?._id ? 'bg-zinc-200' : ''}`}
        >
            <div className={`relative mr-3 ${isOnline ? 'online-indicator' : ''}`}>
                {/* <img 
                    src={user.profilePhoto} 
                    alt={user.username}
                    className="w-12 h-12 rounded-full object-cover"
                /> */}
            </div>
            
            <div className="flex-1 min-w-0">
                <div className="flex justify-between">
                    <h3 className="font-medium truncate">{user.username}</h3>
                    <span className="text-xs text-gray-500 ml-2 whitespace-nowrap">
                        {/* {lastMessage?.createdAt ? formatMessageTime(lastMessage.createdAt) : ''} */}
                        {user.lastMessageTime ? formatMessageTime(user.lastMessageTime) : ''}
                    </span>
                </div>
                
                <div className="flex justify-between items-center mt-1">
                    <p className="text-sm text-gray-500 truncate pr-2">
                        {/* {lastMessage?.message || '\u00A0'} */}
                        {lastMessageContent || '\u00A0'}
                    </p>
                    
                    {unreadCount > 0 && (
                        <div className="flex flex-col items-end">
                            <span className="text-[10px] text-gray-400 mb-1">
                                {/* {lastUnreadMessage?.createdAt && formatMessageTime(lastUnreadMessage.createdAt)} */}
                                {/* {user.lastMessageTime && formatMessageTime(user.lastMessageTime)} */}

                            </span>
                            <span className="bg-green-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                                {unreadCount}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
        <div className="border-b"></div>
        </>
    );
};

export default OtherUser;